import { render } from "./OrderDetailsPage.vue?vue&type=template&id=908572f6&ts=true"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__